import { httpApi } from '@app/api/http.api';
import {
  ContactForm,
  ContactFormPaginatedResponse,
  ContactFormFilters,
  CreateContactFormDto,
  UpdateContactFormDto,
} from '@app/types/api.types';

export const getContactForms = (filters?: ContactFormFilters): Promise<ContactFormPaginatedResponse> =>
  httpApi
    .get<ContactFormPaginatedResponse>('/contact-form', { params: filters })
    .then(({ data }) => data);

export const getContactFormById = (id: string): Promise<ContactForm> =>
  httpApi.get<ContactForm>(`/contact-form/${id}`).then(({ data }) => data);

export const createContactForm = (data: CreateContactFormDto): Promise<ContactForm> =>
  httpApi.post<ContactForm>('/public/contact-form', data).then(({ data }) => data);

export const updateContactForm = (id: string, data: UpdateContactFormDto): Promise<ContactForm> =>
  httpApi.patch<ContactForm>(`/contact-form/${id}`, data).then(({ data }) => data);

export const deleteContactForm = (id: string): Promise<void> =>
  httpApi.delete<void>(`/contact-form/${id}`).then(() => undefined);

